import type { ReactNode } from "react";
import styles from "./EmptyState.module.css";

interface EmptyStateProps {
  /** The primary "nothing here" message. */
  message: string;
  /** Optional action(s) below the message, e.g. a "Clear filters" button. */
  children?: ReactNode;
}

/**
 * Centered empty-state block: a message with optional action below it. Factored
 * out of CatalogPage's inline empty state so the My Skills page (and any future
 * list view) shares the same layout instead of re-inlining it.
 */
export default function EmptyState({ message, children }: EmptyStateProps) {
  return (
    <div className={styles.emptyState}>
      <p className={styles.emptyMessage}>{message}</p>
      {children}
    </div>
  );
}
